'use strict';

//2022-04-06

class Template
{
	// _tpl = null;
	
	constructor(templateName, doc)
	{//2022-04-06
		this._tpl = '';
		doc = doc || document;
		
		const template = doc.querySelector('script[data-template="'+templateName+'"][type="text/html"],template[data-template="'+templateName+'"]');
		
		if(template !== null) this._tpl = template.innerHTML || '';
		
		if(this._tpl.trim() === '') throw 'Template not found ('+templateName+')';
	}
	
	getSource()
	{//2022-04-06
		return this._tpl;
	}
	
	getData(variableName, data)
	{//2022-04-06
		const parts = variableName.split('.');
		
		const name = parts.shift();
		
		if(typeof(data[name]) === 'undefined' || data[name] === null) return '';
		
		if(parts.length === 0) return data[name];
		
		return this.getData(parts.join('.'), data[name]);
	};
	
	compile(data)
	{//2022-04-06
		data = data || {};
		
		if(typeof(data) === 'undefined') throw 'Missing variables';
		
		const templateHTML = this._tpl.replace(/\{\{\{\s?([a-zA-Z0-9_\.]+)\s?\}\}\}/mg, (matchString, variableName) =>	//don't escape variables
		{
			return this.getData(variableName, data);
			
		}).replace(/\{\{\s?([a-zA-Z0-9_\.]+)\s?\}\}/mg, (matchString, variableName) =>	//escape variable
		{
			return this.getData(variableName, data).toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
		});
		
		const template = document.createElement('template');
		template.innerHTML = templateHTML;
		
		const content = template.content.cloneNode(true);
		
		if(content.children.length === 1) return content.children[0];
		
		return content.children;
	};
	
	static createDocFragFromHTML(htmlString)
	{
		const frag = document.createRange().createContextualFragment(htmlString);
		
		return frag;
	};
	
	static createFromHTML(htmlString)
	{
		const template = document.createElement('template');
		template.innerHTML = htmlString;
		
		const content = template.content.cloneNode(true);
		
		if(content.children.length === 1) return content.children[0];
		
		return content.children;
	}

};

export default Template;
